<template>
	<div class="incenters">
		<div style="">
			<Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="StockExport"
				:src="require('@/assets/icon/daoc.png')">
			</Commonbtn>
		</div>
		<!-- style="border: 1px solid blue;" -->
		<div class="TableWidth">
			<Commontable :loadingTable="false" @onRowClick="onRowClick" colnum=7 :tableData="tableData"
				:headerData="headerData" height="100%">
			</Commontable>
			<div class="pagination">
				<Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"
					:total="total"></Pagination>
			</div>
		</div>
	</div>
</template>
<script>
	import Commondropdownlist from '../../../../components/common-dropdownlist.vue'
	import Commontable from '../../../../components/common-table.vue'
	import Commonbtn from '../../../../components/common-btn.vue'
	import Pagination from '../../../../components/pagination.vue'
	import DialogFrom from '../../../../components/dialog-from.vue'
	import fromdata from '../fromData/add'
	import fromdataedit from '../fromData/edit'
	import Dialog from '../../../../components/dialog.vue'
	import headerData from '../table/headerData'
	export default {
		components: {
			Commontable,
			Commonbtn,
			Pagination,
			DialogFrom,
			Commondropdownlist,
			Dialog
		},
		props: {
			tableData: {
				type: Array,
				default: Array
			},
			total: {
				type: Number,
				default: 0
			},
			tableDataMD: {
				type: Array,
				default: Array
			},
		},
		data: function() {
			return {
				dialogVisibles: false,
				dialogVisiblesedit: false,
				dialogVisibledel: false,
				dialogVisibledeactivate: false,
				rightboo: false,
				dwonleft: false,
				ptype: '',
				fromdataadd: [],
				fromdataedit: [],
				headerData: [

				],
				qus: [],
				qx: {
					add: false,
					update: false,
					del: false,
					stopif: true,
					daoc: true,
					assignment: false,
					enabled: false,
					submit: false,
					skip: false, //跳过
					reset: false, //重置
				},
			}
		},
		mounted() {
			this.fromdataadd = JSON.parse(JSON.stringify(fromdata))
			this.fromdataedit = JSON.parse(JSON.stringify(fromdataedit))
			this.headerData = JSON.parse(JSON.stringify(headerData))
			let data = JSON.parse(localStorage.getItem("MenusData"))
			let NodeID = this.$route.query.NodeID
			data.Menus.map((item, index) => {
				if (item.NodeID == 24) {
					this.qus = item.Nodes[2].Nodes[3].Nodes;
				}
			})
			if (this.qus) {
				this.qus.map((item, index) => {
					if (item.NodeName == 'add') {
						this.qx.add = true
					} else if (item.NodeName == 'edit') {
						this.qx.update = true
					} else if (item.NodeName == 'delete') {
						this.qx.del = true
					} else if (item.NodeName == 'stopif') {
						this.qx.del = true
					} else if (item.NodeName == 'assignment') {
						this.qx.assignment = true
					} else if (item.NodeName == 'enabled') {
						this.qx.enabled = true
					} else if (item.NodeName == 'skip') {
						this.qx.skip = true
					} else if (item.NodeName == 'reset') {
						this.qx.reset = true
					}
				})
			}
		},
		methods: {
			onRowClick(val) {
				this.rowboo = true
				//console.log(val, "val")
				this.$emit("onRowClick", val)
			},
			handleCurrentChange(pageindex) {
				this.$emit('handleCurrentChange', pageindex)
			},
			StockExport() {
				this.$emit('StockExport')
			},
			handleSizeChange(paegSzie) {
				this.$emit('handleSizeChange', paegSzie)
			},
			commclick(type) {
				this[type] = true
			},
			adduser() {
				this.dialogVisibles = true
				//console.log(this.fromdataadd, '//console.log(this.fromdataadd)')
			},
			cancel() {
				this.dialogVisibles = false
			},
			dialogOK() {
				this.dialogVisibles = false
			},
			update() {
				this.dialogVisiblesedit = true
			},
			canceledit() {
				this.dialogVisiblesedit = false
			},
			dialogOKedit() {
				this.dialogVisiblesedit = false
			},
			del() {
				this.dialogVisibledel = true
			},
			canceldel() {
				this.dialogVisibledel = false
			},
			dialogOKdel() {
				this.dialogVisibledel = false
			},
			deactivate() {
				this.dialogVisibledeactivate = true
			},
			canceldeactivate() {
				this.dialogVisibledeactivate = false
			},
			dialogOKdeactivate() {
				this.dialogVisibledeactivate = false
			},
		}
	}
</script>

<style lang="less" scoped>
	.incenters {
		height: 100%;

		.pagination {
			display: flex;
			justify-content: center;
			align-items: center;
			margin-top: 16px;
			padding-bottom: 16px;
		}

		// div {
		//   margin-left: 8px;
		//   margin-right: 8px;
		//   margin-top: 5px;
		//   margin-bottom: 5px;

		// }
		.from {
			width: 100%;
		}

		.signingroles {
			height: 500px;
			width: 100%;
			// display: flex;
			// justify-content: space-between;
			// align-items: center;
			// border: 1px solid red;

			.left {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
			}

			.right {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
				// pointer-events: none;
			}
		}
	}

	.right-s {
		position: absolute;
		z-index: 99;
		opacity: 0.5;
		right: 21px;
		width: 470px;
		height: 240px;
		background-color: #ffffff;
		cursor: no-drop;
	}

	.dwonleft {
		width: 170px;
		height: 48px;
		position: absolute;
		background-color: #ffffff;
		z-index: 99;
		right: 350px;
		top: 322px;
		text-align: center;
		line-height: 48px;
		color: #333333;
		box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
			0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
		border-radius: 2px;
		font-size: 14px;
		cursor: pointer;
	}

	.dwonleft:hover {
		background-color: #f0f0f0;
	}
</style>
